module.exports = __webpack_public_path__ + "img/zhuanjiafengcai_bg.880c56e8.png";